import { motion } from "framer-motion";
import MaskedReveal from "@/components/site/MaskedReveal";

const chapters = [
  {
    n: "I.",
    title: "Purpose",
    body:
      "R.I.V.H™ exists to help you find your purpose. Every capsule is a small compass — a garment you can point at your own life.",
  },
  {
    n: "II.",
    title: "Cosmos",
    body:
      "We build with the patience of astronomers. Cotton like dust, leather like planets, hardware like small satellites. Wear the sky quietly.",
  },
  {
    n: "III.",
    title: "Silence",
    body:
      "Nothing shouts. No visible branding — the X is a doorway, not a decoration. Wear it and the room notices before the label does.",
  },
  {
    n: "IV.",
    title: "Ritual",
    body:
      "You do not shop R.I.V.H™. You register, you receive, you walk in. The showroom opens quietly. If you know your purpose, you know.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-32 md:py-48 px-6 md:px-10 bg-black text-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-baseline justify-between mb-16 md:mb-24">
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-white/50">
            § Manifesto — four chapters of purpose
          </span>
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-white/50">
            R.I.V.H™ / DOCTRINE
          </span>
        </div>

        <MaskedReveal
          as="h2"
          trigger="view"
          className="font-display text-6xl md:text-[10rem] uppercase leading-[0.85] tracking-[-0.04em] mb-24 md:mb-32"
          lines={["Wear the sky.", "Find your", "purpose."]}
        />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-24 md:gap-y-32 gap-x-8">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{
                duration: 0.9,
                ease: [0.22, 1, 0.36, 1],
                delay: (i % 2) * 0.15,
              }}
              className={`md:col-span-6 ${
                i % 2 === 0 ? "md:pr-16" : "md:col-start-7 md:pl-16"
              }`}
              data-testid={`manifesto-chapter-${i + 1}`}
            >
              <div className="flex items-start gap-6 border-t border-white/15 pt-8">
                <span className="font-mono text-sm uppercase tracking-[0.3em] text-white/50 pt-2 min-w-[3rem]">
                  {c.n}
                </span>
                <div>
                  <h3 className="font-display uppercase text-3xl md:text-5xl mb-6 tracking-tight">
                    {c.title}
                  </h3>
                  <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-lg">
                    {c.body}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
